export default "__VITE_ASSET__02d5546b__"